export const vendorTypeTableHeader = [
  "Name",
  "Code",
  "Recon Account",
  "Purchasing Organisation",
  "Tax Type",
  "Description",
  "Is Evaluation Required",
  "Status",
  "Created By",
  "Created On",
  "Updated By",
  "Updated On",
];
export const vendorTypeTableData = [
  "name",
  "code",
  "reconAccount",
  "purchasingOrganisation",
  "taxType",
  "description",
  "isEvaluationRequired",
  "status",
  "createdBy",
  "createdDate",
  "updatedBy",
  "updatedDate",
];

export const vendorEvaluationListTableHeader = [
  "Is Existing User",
  "Vendor Code",
  "Factory Name",
  "Owner name",
  "Owner Contact No.",
  "Owner Email Id",
  "Created By",
  "Created On",
  "Updated By",
  "Updated On",
];
export const vendorEvaluationListTableData = [
  "isExistingUser",
  "vendorCode",
  "factoryName",
  "ownerName",
  "ownerContactNo",
  "ownerEmail",
  "createdBy",
  "createdDate",
  "updatedBy",
  "updatedDate",
];

export const vendorRegistrationListTableHeader = [
  "Company Name",
  "Reg No",
  "Vendor Code",
  "Vendor Type",
  "Owner name",
  "Owner Contact No.",
  "Owner Email Id",
  "Approval Status",
  "Approval Remarks",
  "Is PAN Already Exists",
  "Is GST Already Exists",
  "Is ACC No Already Exists",
  "Created By",
  "Created On",
  "Updated By",
  "Updated On",
];
export const vendorRegistrationListTableData = [
  "companyName",
  "regNo",
  "vendorCode",
  "vendorTypeName",
  "ownerName",
  "ownerContactNo",
  "ownerEmail",
  "approvalStatus",
  "approvalRemarks",
  "isPanNoAlreadyExists",
  "isGstNoAlreadyExists",
  "isAccNoAlreadyExists",
  "createdBy",
  "createdDate",
  "updatedBy",
  "updatedDate",
];

export const vendorAmendmentListTableHeader = [
  "Company Name",
  "Amendment No",
  "Vendor Code",
  "Owner Name",
  "Owner Contact No.",
  "Owner Email",
  "Amendment Status",
  "Created By",
  "Created On",
  "Updated By",
  "Updated On",
];

export const vendorAmendmentListTableData = [
  "companyName",
  "amendmentNo",
  "vendorCode",
  "ownerName",
  "ownerContactNo",
  "ownerEmail",
  "amendmentStatus",
  "createdBy",
  "createdDate",
  "updatedBy",
  "updatedDate",
];

export const ledgerApTableHeader = [
  "Account Code",
  "Business Place",
  "Posting Date",
  "Reference Invoice",
  "Assignment",
  "Document Date",
  "Baseline Date",
  "Document Number",
  "Document Type",
  "With Tax Base Amount",
  "Tax Code",
  "Withholding Tax Amount",
  "Debit Amount",
  "Credit Amount",
  "Clearing Document",
  "Clearing Date",
  "Text Remarks",
  "Payment Reference",
  "PO Number",
  "Offset GL",
  "Vendor Invoice Value",
  "Vendor Payment Receipt Value",
  "Vendor Invoice Difference",
  "GST Return Filing Status",
  "Vendor Remarks",
];

export const ledgerApTableData = [
  "vendorCode",
  "bussinessPlace",
  "postingDate",
  "referenceInvoice",
  "assignment",
  "documentDate",
  "baselineDate",
  "documentNumber",
  "documentType",
  "withTaxBaseAmount",
  "taxCode",
  "withholdingTaxAmount",
  "debitAmount",
  "creditAmount",
  "clearingDocument",
  "clearingDate",
  "textRemarks",
  "paymentReference",
  "poNum",
  "offsetAccountGL",
  "vendorInvoiceValue",
  "vendorPaymentReceiptValue",
  "vendorInvoicePaymentDifference",
  "gstReturnFilingStatus",
  "vendorRemarks",
];

export const ledgerApTableVendorHeader = [
  "Posting Date",
  "Reference Invoice",
  "Assignment",
  "Document Date",
  "Document Number",
  "Document Type",
  "Withholding Tax Amount",
  "Debit Amount",
  "Credit Amount",
  "Clearing Document",
  "Clearing Date",
  "Text Remarks",
  "PO Number",
  "Vendor Invoice Value",
  "Vendor Payment Receipt Value",
  "GST Return Filing Status",
  "Vendor Remarks",
];

export const ledgerApTableVendorData = [
  "postingDate",
  "referenceInvoice",
  "assignment",
  "documentDate",
  "documentNumber",
  "documentType",
  "withholdingTaxAmount",
  "debitAmount",
  "creditAmount",
  "clearingDocument",
  "clearingDate",
  "textRemarks",
  "poNum",
  "vendorInvoiceValue",
  "vendorPaymentReceiptValue",
  "gstReturnFilingStatus",
  "vendorRemarks",
];

export const documentTypeTableHeader = [
  "Code",
  "Name",
  "Created By",
  "Created On",
  "Updated By",
  "Updated On",
];
export const documentTypeTableData = [
  "code",
  "name",
  "createdBy",
  "createdDate",
  "updatedBy",
  "updatedDate",
];

export const offsetGlTypeTableHeader = [
  "Code",
  "Name",
  "Created By",
  "Created On",
  "Updated By",
  "Updated On",
];
export const offsetGlTypeTableData = [
  "code",
  "name",
  "createdBy",
  "createdDate",
  "updatedBy",
  "updatedDate",
];

export const vendorRegistrationHistoryTableHeader = [
  "Last Updated On",
  "Company Name",
  "Vendor Code",
  "Vendor Type",
  "Nature of Business",
  "Year of Establishment",
  "Approval Status",
  "Approval Remarks",
  "Company Street",
  "Address Line 1",
  "Address Line 2",
  "Address Line 3",
  "Address Line 4",
  "Address Line 5",
  "City",
  "State",
  "Country",
  "Postal Code",

  "Owner Name",
  "Owner Father Name",
  "Owner Contact No",
  "Owner Email",

  "Partner Name",
  "Partner Contact No",
  "Partner Email",

  "Primary Contact Name",
  "Primary Contact Designation",
  "Primary Contact No",
  "Primary Contact Email",

  "Secondary Contact 1 Name",
  "Secondary Contact 1 Designation",
  "Secondary Contact 1 No",
  "Secondary Contact 1 Email",

  "Secondary Contact 2 Name",
  "Secondary Contact 2 Designation",
  "Secondary Contact 2 No",
  "Secondary Contact 2 Email",

  "Factory Same As Company",
  "Factory Street",
  "Factory Address Line 1",
  "Factory Address Line 2",
  "Factory Address Line 3",
  "Factory Address Line 4",
  "Factory Address Line 5",
  "Factory City",
  "Factory State",
  "Factory Country",
  "Factory Postal Code",

  "Factory Licence No",
  "No Of Plants",
  "Total Area",
  "Production Capacity / Shift",
  "Production Capacity / Month",
  "No Of Employees",
  "Own/Rental Details",

  "Turnover Year 1",
  "Revenue Year 1",
  "Turnover Year 2",
  "Revenue Year 2",
  "Turnover Year 3",
  "Revenue Year 3",

  "Product Range 1",
  "Business % 1",
  "Product Range 2",
  "Business % 2",
  "Product Range 3",
  "Business % 3",
  "Product Range 4",
  "Business % 4",
  "Product Range 5",
  "Business % 5",

  "Customer 1",
  "Customer 2",
  "Customer 3",
  "Customer 4",
  "Customer 5",

  "ITR Ack No 1",
  "ITR Date 1",
  "ITR Ack No 2",
  "ITR Date 2",

  "GST No",
  "PAN No",
  "Aadhar Linked",

  "MSME Declaration",
  "MSME Type",
  "MSME No",

  "ESI No",
  "PF No",

  "Bank Name",
  "Branch",
  "IFSC Code",
  "Account No",

  "Payment Terms",

  "Withholding Tax Type",
  "Withholding Tax Code",
  "Subject",
  "QSREC",

  "Comments",
  "Agree Terms",
    "Is PAN Already Exists",
  "Is GST Already Exists",
  "Is ACC No Already Exists",

  "Created By",
  "Created On",
  "Updated By",
];

export const vendorRegistrationHistoryTableData = [
  "updatedDt",
  "companyName",
  "vendorCode",
  "vendorTypeName",
  "natureOfBusiness",
  "yearOfEstablishment",
  "approvalStatus",
  "approvalRemarks",
  "companyStreetDoorNo",
  "companyAddressLine1",
  "companyAddressLine2",
  "companyAddressLine3",
  "companyAddressLine4",
  "companyAddressLine5",
  "companyCity",
  "companyStateRegion",
  "companyCountry",
  "companyPostalCode",

  "ownerName",
  "ownerFathersName",
  "ownerContactNo",
  "ownerEmail",

  "partnerName",
  "partnerContactNo",
  "partnerEmail",

  "primaryContactName",
  "primaryContactDesignation",
  "primaryContactNo",
  "primaryContactEmail",

  "secondaryContactName",
  "secondaryContactDesignation",
  "secondaryContactNo",
  "secondaryContactEmail",

  "secondaryContactName2",
  "secondaryContactDesignation2",
  "secondaryContactNo2",
  "secondaryContactEmail2",

  "factoryAddressSameAsCompany",
  "factoryStreetDoorNo",
  "factoryAddressLine1",
  "factoryAddressLine2",
  "factoryAddressLine3",
  "factoryAddressLine4",
  "factoryAddressLine5",
  "factoryCity",
  "factoryStateRegion",
  "factoryCountry",
  "factoryPostalCode",

  "factoryLicenceNo",
  "noOfPlants",
  "totalAreaSqft",
  "totalProductionCapacityPerShift",
  "totalProductionCapacityPerMonth",
  "numberOfEmployeesLabours",
  "ownRentalDetails",

  "turnoverYear1",
  "turnoverRevenue1",
  "turnoverYear2",
  "turnoverRevenue2",
  "turnoverYear3",
  "turnoverRevenue3",

  "natureProductRange1",
  "natureBusinessShare1",
  "natureProductRange2",
  "natureBusinessShare2",
  "natureProductRange3",
  "natureBusinessShare3",
  "natureProductRange4",
  "natureBusinessShare4",
  "natureProductRange5",
  "natureBusinessShare5",

  "top5Customer1",
  "top5Customer2",
  "top5Customer3",
  "top5Customer4",
  "top5Customer5",

  "itrAcknowledgementNo1",
  "itrDateOfFiling1",
  "itrAcknowledgementNo2",
  "itrDateOfFiling2",

  "statutoryGstNo",
  "statutoryPanNo",
  "aadharLinkWithPan",

  "msmeDeclaration",
  "msmeType",
  "msmeNo",

  "esiNo",
  "pfNo",

  "statutoryBankName",
  "branch",
  "statutoryIfscCode",
  "statutoryAccountNumber",

  "paymentTerms",

  "withholdingTaxType",
  "withholdingTaxCode",
  "subject",
  "qsrec",

  "overallComments",
  "agreeTerms",
  "isPanNoAlreadyExists",
  "isGstNoAlreadyExists",
  "isAccNoAlreadyExists",

  "createdBy",
  "createdDt",
  "updatedBy",
];

export const paymentTermsTableHeader = [
  "Code",
  "Name",
  "Created By",
  "Created On",
  "Updated By",
  "Updated On",
];
export const paymentTermsTableData = [
  "code",
  "name",
  "createdBy",
  "createdDate",
  "updatedBy",
  "updatedDate",
];

export const vendorBulkInviteListTableHeader = [
  "Vendor Code",
  "Vendor Name",
  "Brand",
  "Vendor Type",
  "Vendor Classification",
  "Invite Status",
  "Owner Mail ID",
  "Owner Contact No",
  "Primary Mail ID",
  "Primary Contact",
  "Vendor Confirm Date",
  "Actions",
];

export const vendorBulkInviteListTableData = [
  "vendorCode",
  "vendorName",
  "brand",
  "vendorType",
  "vendorClassification",
  "inviteStatus",
  "ownerEmail",
  "ownerContactNo",
  "primaryEmail",
  "primaryContact",
  "vendorConfirmDate",
  "actions",
];

export const createBulkInviteTableHeader = [
  "Actions",
  "Send Email",
  "Vendor Code",
  "Vendor Name",
  "Brand",
  "Vendor Type",
  "Vendor Classification",
  "Owner Mail ID",
  "Owner Contact No",
  "Primary Mail ID",
  "Primary Contact",
];

export const createBulkInviteTableData = [
  "sendEmail",
  "vendorCode",
  "vendorName",
  "brand",
  "vendorType",
  "vendorClassification",
  "ownerEmail",
  "ownerContactNo",
  "primaryEmail",
  "primaryContact",
];